import { ExtLink } from '../components/ExtLink'

interface Item {
  name: string
  href: string
  desc: string
}

const DATASETS: Item[] = [
  {
    name: 'AMBL (Advanced-MRI-Breast-Lesions)',
    href: 'https://www.cancerimagingarchive.net/collection/advanced-mri-breast-lesions/',
    desc: '99 hastadan 165 lezyonluk açık erişimli kontrastlı meme MR koleksiyonu, uzman radyolog çizimli maskelerle. Sınıflandırıcının birincil eğitim kaynağı.',
  },
  {
    name: 'BREAST-DIAGNOSIS',
    href: 'https://www.cancerimagingarchive.net/collection/breast-diagnosis/',
    desc: '45 hastalık çok fazlı kontrastlı meme MR koleksiyonu. Kombine modelin eğitiminde ve kohortlar arası testte kullanıldı.',
  },
  {
    name: 'MAMA-MIA',
    href: 'https://www.synapse.org/Synapse:syn60868042',
    desc: 'Çok merkezli, yaklaşık 1500 hastalık kontrastlı meme MR veri kümesi. Segmentasyon modelinin temel ön eğitimini sağladı.',
  },
  {
    name: 'The Cancer Imaging Archive (TCIA)',
    href: 'https://www.cancerimagingarchive.net/',
    desc: 'AMBL ve BREAST-DIAGNOSIS koleksiyonlarını barındıran açık erişim tıbbi görüntü arşivi.',
  },
]

const ML: Item[] = [
  {
    name: 'nnU-Net',
    href: 'https://github.com/MIC-DKFZ/nnUNet',
    desc: 'Tıbbi görüntü segmentasyonu için kendi kendini yapılandıran U-Net çerçevesi. Sezi’nin lezyon segmentasyon modeli buna dayanır.',
  },
  {
    name: 'PyTorch',
    href: 'https://pytorch.org/',
    desc: 'Tüm derin öğrenme modellerinin eğitiminde ve canlı modda çıkarım sırasında kullanılan kütüphane.',
  },
  {
    name: 'MONAI',
    href: 'https://monai.io/',
    desc: 'Tıbbi görüntü işlemeye özel PyTorch tabanlı yardımcı kütüphane. Ön işleme dönüşümleri ve veri yükleme için kullanıldı.',
  },
  {
    name: 'SimpleITK',
    href: 'https://simpleitk.org/',
    desc: 'NIfTI / DICOM görüntülerini okuma, yeniden örnekleme ve yazma için temel kütüphane.',
  },
  {
    name: 'scikit-image',
    href: 'https://scikit-image.org/',
    desc: 'Yürüyen küpler (marching cubes) algoritmasıyla segmentasyon maskelerinden 3B yüzey çıkarmak için kullanıldı.',
  },
  {
    name: 'trimesh',
    href: 'https://github.com/mikedh/trimesh',
    desc: '3 boyutlu yüzey ağı işleme: Taubin yumuşatma ve glTF dışa aktarma.',
  },
  {
    name: 'pyradiomics',
    href: 'https://github.com/AIM-Harvard/pyradiomics',
    desc: 'Klasik radyomik özniteliklerin (şekil, doku, yoğunluk) çıkarımı ve karşılaştırma temel modeli için kullanıldı.',
  },
  {
    name: 'XGBoost',
    href: 'https://xgboost.readthedocs.io/',
    desc: 'Radyomik öznitelikler üzerinde temel sınıflandırıcı olarak kullanıldı.',
  },
  {
    name: 'scikit-learn',
    href: 'https://scikit-learn.org/',
    desc: 'Çapraz doğrulama bölmeleri, metrik hesaplama, kalibrasyon yardımcıları.',
  },
  {
    name: 'highdicom',
    href: 'https://github.com/ImagingDataCommons/highdicom',
    desc: 'AMBL koleksiyonundaki DICOM-SEG biçimli lezyon maskelerinin okunması için.',
  },
]

const WEB: Item[] = [
  {
    name: 'FastAPI',
    href: 'https://fastapi.tiangolo.com/',
    desc: 'Sezi’nin REST API uç noktalarını sağlayan Python çerçevesi.',
  },
  {
    name: 'Uvicorn',
    href: 'https://www.uvicorn.org/',
    desc: 'FastAPI uygulamasının çalıştığı ASGI sunucusu.',
  },
  {
    name: 'React',
    href: 'https://react.dev/',
    desc: 'Bu arayüzün kullandığı kullanıcı arayüzü kütüphanesi.',
  },
  {
    name: 'Vite',
    href: 'https://vitejs.dev/',
    desc: 'Geliştirme ve üretim derlemesi için kullanılan hızlı yapı aracı.',
  },
  {
    name: 'Tailwind CSS',
    href: 'https://tailwindcss.com/',
    desc: 'Bu sayfaların stilini sağlayan yardımcı sınıf odaklı CSS çerçevesi.',
  },
  {
    name: '<model-viewer>',
    href: 'https://modelviewer.dev/',
    desc: 'Google’ın geliştirdiği, tarayıcıda glTF modelleri gösteren web bileşeni. 3 boyutlu lezyon görüntüleyicisi.',
  },
  {
    name: 'NIFTI-Reader-JS',
    href: 'https://github.com/rii-mango/NIFTI-Reader-JS',
    desc: 'Tarayıcıda NIfTI dosyalarını çözümlemek için kullanılan kütüphane. Aksiyel kesit görüntüleyicisi buna dayanır.',
  },
  {
    name: 'pako',
    href: 'https://github.com/nodeca/pako',
    desc: 'Tarayıcıda gzip açma; sıkıştırılmış .nii.gz dosyalarını okumak için kullanıldı.',
  },
]

const INFRA: Item[] = [
  {
    name: 'Cloudflare Tunnel',
    href: 'https://www.cloudflare.com/products/tunnel/',
    desc: 'Bu demo örneğini geçici olarak internete açmak için kullanıldı.',
  },
]

export function Thanks() {
  return (
    <div className="max-w-3xl mx-auto py-6">
      <h1 className="text-2xl sm:text-3xl font-semibold text-text mb-2">Teşekkürler</h1>
      <p className="text-text-dim mb-8">
        Sezi, açık veri kümeleri ve açık kaynak kütüphaneler üzerine inşa edilmiştir. Bu
        sayfa, projede doğrudan kullanılan kaynakları listeler. Tüm bu projelerin
        sahiplerine ve katkıda bulunanlara teşekkür ederiz.
      </p>

      <Section title="Veri kümeleri" items={DATASETS} />
      <Section title="Makine öğrenmesi ve görüntü işleme" items={ML} />
      <Section title="Web uygulaması" items={WEB} />
      <Section title="Altyapı" items={INFRA} />

      <div className="mt-10 border-t border-border pt-6 text-sm text-text-dim leading-relaxed">
        <p>
          Eksik kaldığını düşündüğünüz veya yanlış atfedilmiş bir kaynak görürseniz lütfen
          dikkatime sunun, güncellensin. Veri kümelerini kullanırken kendi yayın koşullarına
          ve atıf gereksinimlerine dikkat ediniz.
        </p>
      </div>
    </div>
  )
}

function Section({ title, items }: { title: string; items: Item[] }) {
  return (
    <section className="mb-8">
      <h2 className="text-xl font-medium text-text mb-3 border-b border-border pb-2">
        {title}
      </h2>
      <ul className="space-y-3">
        {items.map((it) => (
          <li key={it.href} className="border-l-2 border-border pl-4">
            <div>
              <ExtLink href={it.href}>
                <strong className="text-text">{it.name}</strong>
              </ExtLink>
            </div>
            <p className="text-text-dim text-sm mt-1 leading-relaxed">{it.desc}</p>
          </li>
        ))}
      </ul>
    </section>
  )
}
